module.exports = __webpack_public_path__ + "img/hawk.e0876575.png";